import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

export const refundSlice = createSlice({
    name: "refund",
    initialState: {
        message: null,
        loading: false,
        model: false,
        drawer: false,
        error_msg: null,
        listCount: 0,
        refundList: [],
        refundParams: {
            start_date: "",
            end_date: "",
            no_of_pages: 0,
            page_size: 10,
            page: 1,
            search: "",
            currentSort: "code",
            sortOrder: "-",
            advance_request: "",
            approval_status: "",
            refund_mode: "",
            customer: "",
            vehicle: "",
            ordering: ""
        },
        rowdata: {},
        refundViewData: {},
        viewModel: false,
        customerByIdList: {},
        checkApprove: false,
        filterStatus: false,
        rejectReasonObjData: {},
        RejectMode: false,

    },
    reducers: {

        getrefundList: (state, action) => {
            if (state.refundParams?.page == 1) {
                return {
                    ...state,
                    loading: true,
                    refundList: [],
                };
            } else {
                return {
                    ...state,
                    loading: true,
                };
            }
        },
        // refundListSuccessful: (state, action) => {
        //     var noofpages = Math.ceil(
        //         action.payload.response.count / state.refundParams.page_size
        //     );

        //     console.log("🔥 BEFORE UPDATE:", action.payload.response.results);

        //     const newState = {
        //         ...state,
        //         listCount: action.payload.response.count,
        //         refundList: action.payload.response.results,
        //         loading: false,
        //         refundParams: {
        //             ...state.refundParams,
        //             no_of_pages: noofpages,
        //         },
        //     };

        //     console.log("✅ AFTER UPDATE:", newState.refundList);

        //     return newState;
        // },
        refundListSuccessful: (state, action) => {
            console.log("🔥 BEFORE UPDATE:", action.payload.results);

            const newState = {
                ...state,
                listCount: action.payload.count,
                refundList: action.payload.results,
                loading: false,
                refundParams: {
                    ...state.refundParams,
                    no_of_pages: Math.ceil(
                        action.payload.count / state.refundParams.page_size
                    ),
                },
            };

            console.log("✅ AFTER UPDATE:", newState.refundList);

            return newState;
        },

        clearrefundList: (state, action) => {
            return {
                ...state,
                loading: true,
                refundList: [],
            };
        },

        getrefundHistory: (state, action) => {
            return {
                ...state,
                loading: true,
                refundHistoryList: [],
            };
        },

        SetrefundParams: (state, action) => {
            return {
                ...state,
                refundParams: action.payload,
            };
        },

        addrefund: (state, action) => {
            return {
                ...state,
                formSubmitLoading: true,
            };
        },
        addrefundSuccessful: (state, action) => {
            return {
                ...state,
                formSubmitLoading: false,
            };
        },
        refundClear: (state, action) => {
            return {
                ...state,
                loading: false,
                refundData: {},
                vehicleVersion: {},
                insuranceData: {},
            };
        },

        getVehicleData: (state, action) => {
            return {
                ...state,
                loading: true,
                vehicleData: {},
            };
        },
        vehicleDataSuccessful: (state, action) => {
            return {
                ...state,
                vehicleData: action.payload.response,
                loading: false,
            };
        },



        refundApproval: (state) => {
            return {
                ...state,
                loading: true,
            };
        },
        getrefundCheckApprove: (state) => {
            return {
                ...state,
                loading: true,
                checkApprove: false,
            };
        },
        refundsCheckApproveSuccessful: (state, action) => {
            return {
                ...state,
                loading: false,
                checkApprove: action.payload,
            };
        },
        isRejectModelVisible: (state, action) => {
            return {
                ...state,
                RejectMode: action.payload,
                refundRejectData: {},
                loading: false,
            };
        },
        rejectModelInputChangeValue: (state, action) => {
            return {
                ...state,
                refundRejectData: {
                    ...state.refundRejectData,
                    [action.payload.key]: action.payload.value,
                },
                loading: false,
            };
        },

        refundDelete: (state) => {
            return {
                ...state,
                loading: false,
            };
        },
        setrefundParams: (state, action) => {
            return {
                ...state,
                refundParams: action.payload,
            };
        },
        isDrawerVisible: (state, action) => {
            if (!action.payload) {
                return {
                    ...state,
                    drawer: action.payload,
                    rowdata: {},
                };
            } else {
                return {
                    ...state,
                    drawer: action.payload,
                };
            }
        },
        getCustomerById: (state, action) => {
            return {
                ...state,
                loading: true,
                customerByIdList: action.payload,
            };
        },
        getrefundByID: (state) => {
            return {
                ...state,
                loading: true,
                rowdata: {},
            };
        },

        refundByIDSuccessful: (state, action) => {
            const response = action.payload.response;

            return {
                ...state,
                loading: false,
                rowdata: {
                    id: response.id,

                    // ✅ Refund-level details
                    refund_date: response.refund_date,
                    refund_amount: response.refund_amount,
                    refund_mode: response.refund_mode,
                    refund_mode_name: response.refund_mode_name,
                    refund_reason: response.refund_reason,
                    refund_status: response.refund_status,
                    refund_status_name: response.refund_status_name,
                    approval_status: response.approval_status,
                    approval_status_name: response.approval_status_name,

                    // ✅ Advance request-level details
                    advance_request_id: response.advance_request?.id,
                    advance_code: response.advance_request?.code,
                    advance_amount: response.advance_request?.advance_amount,
                    request_date: response.advance_request?.request_date,
                    payment_mode: response.advance_request?.payment_mode,
                    payment_mode_name: response.advance_request?.payment_mode_name,

                    // ✅ Customer details
                    customer_id: response.advance_request?.customer?.id,
                    customer_name: `${response.advance_request?.customer?.firstname || ""} ${response.advance_request?.customer?.lastname || ""}`.trim(),
                    customer_mobile: response.advance_request?.customer?.mobile,
                    customer_aadhar: response.advance_request?.customer?.aadharno,

                    // ✅ Vehicle details
                    vehicle_id: response.advance_request?.vehicle?.id,
                    vehicleno: response.advance_request?.vehicle?.vehicleno,
                    year: response.advance_request?.vehicle?.year,
                    engineno: response.advance_request?.vehicle?.engineno,
                    chassisno: response.advance_request?.vehicle?.chassisno,

                    // ✅ Version details
                    version_name: response.advance_request?.vehicle?.version?.name,
                    brand_name: response.advance_request?.vehicle?.version?.brand?.name,
                    model_name: response.advance_request?.vehicle?.version?.model?.name,
                    fueltype_name: response.advance_request?.vehicle?.version?.fueltype_name,
                    enginedisplacement_name: response.advance_request?.vehicle?.version?.enginedisplacement_name,

                    // ✅ Created/Modified info
                    createdby: response.createdby,
                    createdon: response.createdon,
                    approved_by: response.approved_by,
                    approved_on: response.approved_on,
                },

                model: action.payload.type === "update",
                viewModel: action.payload.type === "view",
                refundViewData: response,
            };
        },

        InputChangeValue: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    [action.payload.key]: action.payload.value,
                },
            };
        },
        getRejectReasonData: (state, action) => {
            return {
                ...state,
                loading: true,
                rejectReasonObjData: action.payload,
            };
        },

        checkFilterStatus: (state, action) => {
            return {
                ...state,
                filterStatus: action.payload,
            };
        },
        apiError: (state, action) => {
            return {
                ...state,
                loading: false,
                formSubmitLoading: false,
                error_msg: action.payload,
            };
        },

        isModelVisible: (state, action) => {
            if (action.payload) {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                    refundViewData: {},
                };
            } else {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                    refundViewData: {},
                };
            }
        },
        isViewModelVisible(state, action) {
            if (!action.payload) {
                return {
                    ...state,
                    viewModel: false,
                    loading: false,
                };
            }
            return {
                ...state,
                viewModel: true,
            };
        },


        FilterInputChangeValue: (state, action) => {
            return {
                ...state,
                loanParams: {
                    ...state.loanParams,
                    [action.payload.key]: action.payload.value,
                },
            };
        },


    },
});

// Action creators are generated for each case reducer function
export const {
    getrefundList,
    refundListSuccessful,
    clearrefundList,
    addrefund,
    addrefundSuccessful,
    refundClear,
    InputChangeValue,
    getVehicleData,
    vehicleDataSuccessful,
    refundApproval,
    getrefundCheckApprove,
    refundsCheckApproveSuccessful,
    isRejectModelVisible,
    rejectModelInputChangeValue,
    setrefundParams,
    refundDelete,
    isDrawerVisible,
    FilterInputChangeValue,
    getCustomerById,
    getRejectReasonData,
    checkFilterStatus,
    apiError,
    getrefundByID,
    refundByIDSuccessful,
    isModelVisible,
    isViewModelVisible

} = refundSlice.actions;

export default refundSlice.reducer;
